module.exports = __webpack_public_path__ + "static/assets/58d87881bfa7e0bacf6c1bf85ebd98ff.png";